var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-simplemde',{ref:"editor",attrs:{"configs":_vm.options,"name":_vm.name},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }